import React from "react";
import { useState } from "react";
import TopLeftUserName from "../components/TopLeftUserName";
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
} from "@ionic/react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
const About = () => {
  let history = useHistory();

  //Read fdaVersion and deviceInfo.appVersion from local storage
  const fdaVersion = localStorage.getItem("fdaVersion")!;
  const deviceInfo = JSON.parse(localStorage.getItem("deviceInfo")!);

  return (
    <IonPage placeholder={undefined}>
      <IonHeader className="ion-no-border" placeholder={undefined}>
        <TopLeftUserName headerText={"About"}></TopLeftUserName>
        <IonGrid className="container" placeholder={undefined}></IonGrid>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="py-42 ph-16">
                <h6 className="generic-info-heading mb-12">Release Version</h6>
                <p className="generic-info-desc">
                  {fdaVersion}v{deviceInfo && deviceInfo.appVersion}
                </p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonFooter className="ion-no-border" placeholder={undefined}>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="btn-wrap-sec">
                <Link to="/termofservices">
                  <IonButton
                    className="generic-btn-outline"
                    placeholder={undefined}
                  >
                    Terms of Service
                  </IonButton>
                </Link>
                <Link to="/privacypolicy">
                  <IonButton
                    className="generic-btn-outline"
                    placeholder={undefined}
                  >
                    Privacy Policy
                  </IonButton>
                </Link>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};

export default About;
